module.exports = __webpack_public_path__ + "img/15.671ffd28.png";